import type { AxiosResponse } from "axios";
import { usePaginatedApi } from "../../../swr/useApi";
import { comparisonsService } from "../../api_client";
import type { ProductsQueryDto } from "../../../api";
import type { PaginatedResponse } from "../../pagination/data";
import type { ComparisonsQuery, SavedComparisonDto } from "../data/comparison.types";

/** Shared with the save flow so it can invalidate every cached page after a save. */
export const COMPARISONS_SWR_KEY = "/api/v1/comparisons";

export function useMyComparisons(query?: ComparisonsQuery) {
  const q: ProductsQueryDto = {
    page: Number(query?.page ?? 1),
    pageSize: Number(query?.pageSize ?? 10),
    search: query?.search?.trim() || undefined,
    sortBy: query?.sortBy ?? "createdAt",
    sortOrder: query?.sortOrder ?? "desc",
  };

  return usePaginatedApi<SavedComparisonDto, ProductsQueryDto>({
    key: COMPARISONS_SWR_KEY,
    // listMyComparisons is generated against `ProductsQueryDto` (OpenAPI naming
    // quirk — it's really the comparisons query shape); response is cast to the
    // hand-typed SavedComparisonDto the rest of this module already uses.
    serviceMethod: (query) =>
      comparisonsService.listMyComparisons(query) as unknown as Promise<
        AxiosResponse<PaginatedResponse<SavedComparisonDto>>
      >,
    query: q,
    // Without this the list unmounts to a shimmer on every search keystroke
    // and page change, since each query builds a new SWR cache key.
    options: { keepPreviousData: true },
  });
}
